var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcWindowsActive = function SvgIcWindowsActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "ic-windows-active_svg__ic-windows-active",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#04ACEF",
    fillRule: "evenodd",
    d: "M1 14.667v-8.4l9.333-2v10.4H1zm0 2.667h9.333v10.933L1 26.533v-9.199zM30.333 0v14.667H13V3.733L30.333 0zm0 17.333V32L13 28.8V17.333h17.333z"
  })));
};
export default SvgIcWindowsActive;